import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { ShopLogoComponent } from '@plys/src/ui/shop-logo/shop-logo.component';
import { Observable } from 'rxjs';

export interface ErrorPageRouteData {
  titleKey: string;
  messageKey: string;
}

@Component({
  imports: [CommonModule, TranslocoModule, ShopLogoComponent],
  templateUrl: './error-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent {
  data$ = this.route.data as Observable<ErrorPageRouteData>;

  constructor(private route: ActivatedRoute) {}
}
